module.exports = __webpack_public_path__ + "img/2-3.8c70f4d3.png";